<template>
  <div>
    <TitleField fieldName="isTrustee" :fieldGroup="fieldGroup" />
    <TrusteeSection :data="trusteeBase" documents-hidden />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="$v.trustee.trusteeStatus.$model"
          :errorMessages="getValidationErrorText($v.trustee.trusteeStatus)"
          :label="FieldLabel.TRUSTEE_STATUS"
          outlined
        />
      </v-col>
    </v-row>

    <EgrnOrganizationAuthorityDocument
      :v="$v.trustee.documents.authorityDocument"
    />

    <slot name="footer" :next="nextHandler"></slot>
  </div>
</template>

<script>
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import { getValidationErrorText } from '@/utils/validate';
import EgrnOrganizationAuthorityDocument from '@/components/services/elements/EgrnOrganizationAuthorityDocument';
import cloneDeep from 'clone-deep';
import { FieldGroup } from '@/utils/fullStatementView';
import deepmerge from 'deepmerge';
import { getTrusteeFieldGroup } from '@/utils/common';
import { FieldLabel } from '@/constants';
import {
  getOrganizationTrusteeValidation,
  organizationTrusteeModel,
} from '@/components/services/EgrnConfirm/Applicant/components/OrganizationTrustee';

export default {
  name: 'TrusteeInfo',
  components: {
    TitleField,
    TrusteeSection,
    EgrnOrganizationAuthorityDocument,
  },
  props: {
    trusteeInfoProp: {
      type: Object,
    },
    assigneeProp: {
      type: Object,
    },
    fieldGroup: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    FieldGroup,
    FieldLabel,
    getTrusteeFieldGroup,
    getValidationErrorText,
    trustee: {
      trusteeStatus: organizationTrusteeModel.trusteeStatus,
      documents: cloneDeep(organizationTrusteeModel.documents),
    },
  }),
  computed: {
    trusteeBase() {
      const trusteeProp = this.trusteeInfoProp || this.assigneeProp;

      return {
        lastName: trusteeProp.lastName,
        firstName: trusteeProp.firstName || trusteeProp.name,
        patronymic: trusteeProp.patronymic,
        snils: trusteeProp.snils,
        inn: trusteeProp.inn,
        email: trusteeProp.email,
        phone: trusteeProp.phone,
      };
    },
  },
  validations() {
    const trusteeValidation = getOrganizationTrusteeValidation(this.trustee);

    return {
      trustee: {
        trusteeStatus: trusteeValidation.trusteeStatus,
        documents: trusteeValidation.documents,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (this.trusteeInfoProp) {
        this.trustee = deepmerge(this.trustee, this.trusteeInfoProp);
      }
    },

    assemblyModel() {
      const trusteeProp = this.trusteeInfoProp || this.assigneeProp;

      return {
        lastName: trusteeProp.lastName,
        firstName: trusteeProp.firstName || trusteeProp.name,
        patronymic: trusteeProp.patronymic,
        snils: trusteeProp.snils,
        inn: trusteeProp.inn,
        email: trusteeProp.email,
        phone: trusteeProp.phone,
        trusteeStatus: this.trustee.trusteeStatus,
        documents: cloneDeep(this.trustee.documents),
      };
    },

    async nextHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        return;
      }

      this.$emit('send', this.assemblyModel());
    },
  },
};
</script>
